import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Page from '../pages/Page'
import SchemaTable from '../table/SchemaTable'
import FormattedDate from '../table/FormattedDate'
import FetchContext from '../../context/fetch/FetchContext'
import EmailDailyTotals from './EmailDailyTotals'
import { DASH, EMAIL_KIND_LABELS, EMAIL_OUTCOME_LABELS, labelOf, NO_FIRM_LABEL } from './emailLabels'

export const EMAILS_QUERY_KEY = ['emails']

const COLUMNS = [
    {
        Header: 'מועד',
        accessor: 'createdAt',
        Cell: (cell) => <FormattedDate value={cell.row.original.createdAt} />,
    },
    { Header: 'סוג', accessor: 'kind' },
    { Header: 'משרד', accessor: 'firmName' },
    { Header: 'מאת', accessor: 'fromAddress' },
    { Header: 'אל', accessor: 'toAddress' },
    { Header: 'נושא', accessor: 'subject' },
    { Header: 'מצב', accessor: 'outcome' },
]

export function resolveEmailRows(messages = []) {
    return messages.map((message) => ({
        id: message.id,
        createdAt: message.createdAt,
        kind: labelOf(EMAIL_KIND_LABELS, message.kind),
        firmName: message.firm?.name ?? NO_FIRM_LABEL,
        fromAddress: message.fromAddress,
        toAddress: message.toAddress,
        subject: message.subject ?? DASH,
        outcome: labelOf(EMAIL_OUTCOME_LABELS, message.outcome),
    }))
}

export default function EmailPage() {
    const navigate = useNavigate()
    const fetcher = useContext(FetchContext)

    const { data, isLoading } = useQuery({
        queryKey: EMAILS_QUERY_KEY,
        queryFn: () => fetcher.fetchEmails(),
    })

    const commands = [
        {
            scheme: 'link',
            label: 'בדיקת דואר',
            to: '/emails/test',
            position: 'start',
        },
    ]

    return (
        <Page
            className="email"
            title="דואר יוצא"
            commands={commands}
            busy={isLoading}
        >
            <EmailDailyTotals totals={data?.totals ?? []} />
            <SchemaTable
                data={resolveEmailRows(data?.messages)}
                columns={COLUMNS}
                canSearch
                onRowClick={(row) => navigate(`/emails/${row.id}`)}
            />
        </Page>
    )
}
